// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* api key page */
.api-key-container {
  width: 100%;
  padding: 24px 12px 40px 35px;
  max-width: 100%;
  background-color: #fff;
  min-height: 100%;
}

/* Header */
.api-key-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.api-key-header h2 {
  font-size: 40px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
}

.api-key-header p {
  color: #6b7280;
  font-size: 15px;
  margin: 0;
}

.api-key-create-btn {
  background: #343539;
  color: #fff;
  border: none;
  padding: 14px 24px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.api-key-create-btn:hover {
  background: #1f2937;
}

/* Stats Cards */
.api-key-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.api-stat-card {
  border: 1px solid #F3F4F6;
  border-radius: 18px;
  min-height: 132px;
  padding: 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  box-shadow: 0 0px 2px rgb(0 0 0 / 6%);
}

.api-stat-icon {
  width: 65px;
  height: 65px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.api-stat-icon.yellow {
  background: #404246;
  color: #ffffff;
}

body.light_theme .api-stat-icon.yellow {
  background: #FFFBEB;
  color: #B98A2C;
}

.api-stat-icon.green {
  background: #404246;
  color: #ffffff;
}

body.light_theme .api-stat-icon.green {
  background: #F0FDF4;
  color: #22C55E;
}

.api-stat-icon.gray {
  background: #404246;
  color: #ffffff;
}

body.light_theme .api-stat-icon.gray {
  background: #F9FAFB;
  color: #6B7280;
}

.api-stat-icon.blue {
  background: #404246;
  color: #ffffff;
}

body.light_theme .api-stat-icon.blue {
  background: #EFF6FF;
  color: #3B82F6;
}

.api-stat-info h3 {
  margin: 0 0 1px;
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}

.api-stat-info p {
  margin: 0;
  font-size: 15px;
  color: #6b7280;
}

/* Toolbar */
.api-key-toolbar {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  border-bottom: 1px solid #e5e7eb;
}

.apikeytabl_data {
  width: 100%;
  border: 1px solid #f3f4f61c;
  border-radius: 16px;
  /* margin: 26px 0px; */
}

body.light_theme .apikeytabl_data {
  border: 1px solid #F3F4F6;
}

.api-tabs {
  display: flex;
  gap: 32px;
}

.api-tab {
  padding: 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #6B7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: 0;
}

.api-tab.active {
  color: #111827;
  border-bottom-color: #D1AA67;
}

.api-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 0px;
}

.api-search {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 16px;
  background: #fff;
}

.api-search i {
  color: #9ca3af;
}

.api-search input {
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
}

.api-filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

/* Table */
.api-table-wrapper {
  overflow-x: auto;
}

.api-table {
  width: 100%;
  border-collapse: collapse;
}

.api-table th {
  text-align: left;
  padding: 20px 30px;
  font-size: 12px;
  font-weight: 400;
  background-color: #f9fafb08;
  color: #8E939C;
  border-bottom: 1px solid #f3f4f6;
  white-space: nowrap;
}

.api-table td {
  padding: 30px;
  font-size: 13px;
  color: #111827;
  border-bottom: 1px solid #F3F4F6;
  vertical-align: middle;
}

.api-remark-col {
  display: flex;
  align-items: center;
  gap: 12px;
}

.api-remark-icon {
  width: 36px;
  min-width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.api-remark-icon.yellow {
  background: #FFFBEB;
  color: #D97706;
}

.api-remark-icon.purple {
  background: #F3E8FF;
  color: #9333EA;
}

.api-remark-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.api-remark-sub {
  font-size: 11px;
  color: #9ca3af;
}

.api-key-text {
  font-family: monospace;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4b5563;
}

.api-key-text i {
  cursor: pointer;
  color: #9ca3af;
}

.api-type-badge {
  background: #D1FAE5;
  color: #059669;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 50px;
}

.api-type-badge.spot {
  background: #ffe8ba;
  color: #B98A2C;
}

body.light_theme .api-type-badge.spot {
  background: #FBF5E9;
}

.api-type-badge.margin {
  background: #c8ffe5;
  color: #059669;
}

body.light_theme .api-type-badge.margin {
  background: #ECFDF5;
}

.api-perm-badges {
  display: flex;
  gap: 6px;
}

.api-perm-badge {
  background: #aff9d6;
  color: #059669;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

body.light_theme .api-perm-badge {
  background: #ECFDF5;
}

.api-ip-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-weight: 500;
}

.api-ip-col span {
  font-size: 10px;
  color: #9ca3af;
}

.api-date-col {
  color: #cfcfcf;
  line-height: 1.5;
  font-weight: 600;
}

body.light_theme .api-date-col {
  color: #4b5563;
}

.api-date-col div:last-child {
  font-size: 10px;
  font-weight: 300;
  color: #9ca3af;
}

.api-status-active {
  color: #10B981;
  font-weight: 600;
  font-size: 11px;
  background-color: #ECFDF5;
  padding: 4px 10px;
  border-radius: 50px;
}

.api-status-disabled {
  color: #6B7280;
  font-weight: 600;
  font-size: 11px;
  background-color: #F3F4F6;
  padding: 4px 10px;
  border-radius: 50px;
}

.api-status-expired {
  color: #EF4444;
  font-weight: 600;
  font-size: 11px;
  background-color: #FEF2F2;
  padding: 4px 10px;
  border-radius: 50px;
}

.api-action-btns {
  display: flex;
  gap: 8px;
}

.api-action-btns button {
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #4b5563;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.api-action-btns button:hover {
  background: #e5e7eb;
}

.api-action-btns button.delete {
  color: #EF4444;
}

.api-action-btns button.delete:hover {
  background: #FEF2F2;
  border-color: #FECACA;
}

/* Pagination */
.api-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px;
  font-size: 11px;
  color: #6b7280;
}

.api-page-controls {
  display: flex;
  gap: 8px;
}

.api-page-controls button {
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #374151;
}

.api-page-controls button.active {
  background: #111827;
  color: #fff;
  border-color: #111827;
}

.api-page-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Dark theme overrides */
html[data-theme='dark'] body .api-key-container {
  background: transparent;
}

html[data-theme='dark'] body .api-key-header h2,
html[data-theme='dark'] body .api-stat-info h3,
html[data-theme='dark'] body .api-tab.active,
html[data-theme='dark'] body .api-table td,
html[data-theme='dark'] body .api-remark-title {
  color: #fff;
}

html[data-theme='dark'] body .api-stat-card {
  background: #202226;
  border-color: #333;
}

html[data-theme='dark'] body .api-key-toolbar {
  border-color: #333;
}

html[data-theme='dark'] body .api-search,
html[data-theme='dark'] body .api-filter-btn {
  background: #1a1a24;
  border-color: #333;
  color: #ccc;
}

html[data-theme='dark'] body .api-search input {
  color: #fff;
}

html[data-theme='dark'] body .api-table th,
html[data-theme='dark'] body .api-table td {
  border-color: #333;
}

html[data-theme='dark'] body .api-key-text {
  color: #ccc;
}

html[data-theme='dark'] body .api-action-btns button {
  background: #1a1a24;
  border-color: #333;
  color: #ccc;
}

html[data-theme='dark'] body .api-page-controls button {
  background: #1a1a24;
  border-color: #333;
  color: #ccc;
}

html[data-theme='dark'] body .api-page-controls button.active {
  background: #fff;
  color: #111827;
}

html[data-theme='dark'] body .api-tab {
  color: #888;
}

html[data-theme='dark'] body .api-tab.active {
  color: #fff;
}

/* ==================== CREATE NEW API KEY ==================== */
.api-create-container {
  padding: 40px 20px;
  max-width: 1360px;
  margin: 0 auto;
}

.api-breadcrumb {
  font-size: 15px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}

.api-breadcrumb .current {
  color: #111827;
  font-weight: 600;
}

.api-create-layout {
  display: flex;
  gap: 60px;
}

.api-create-form-section {
  flex: 1.5 1;
}

.api-create-form-section h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.subtitle {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 32px;
}

.api-form-group {
  margin-bottom: 24px;
}

.api-form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.api-form-group label .optional {
  color: #9ca3af;
  font-weight: 400;
}

.api-form-group input[type="text"],
.api-form-group input[type="password"] {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ededed;
  border-radius: 12px;
  font-size: 13px;
  outline: none;
  background: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.api-form-group input[type="password"] {
  background-color: #ffffff05 !important;
}

.api-form-group input:focus {
  border-color: #D1AA67;
}

.api-custom-select {
  position: relative;
  width: 100%;
}

.api-select-trigger {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #F3F4F6;
  border-radius: 12px;
  font-size: 13px;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s;
  box-sizing: border-box;
}

.api-select-trigger:hover {
  border-color: #D1AA67;
}

.api-select-trigger i {
  color: #9ca3af;
  font-size: 16px;
}

.api-filter-wrapper {
  position: relative;
}

.api-filter-dropdown {
  left: auto;
  right: 0;
  min-width: 150px;
}

.api-select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 10;
  padding: 4px 0;
  margin: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}

.api-select-options li {
  padding: 10px 16px;
  font-size: 13px;
  color: #111827;
  cursor: pointer;
  transition: all 0.15s;
}

.api-select-options li:hover,
.api-select-options li.selected {
  background-color: #D1AA67;
  color: #fff;
}

.hint {
  display: block;
  font-style: italic;
  font-size: 10px;
  color: #9CA3AF;
  margin-top: 8px;
}

.api-permissions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.api-perm-card {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px 16px;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
}

.api-perm-card input[type="checkbox"] {
  position: absolute;
  top: 12px;
  left: 12px;
  accent-color: #D1AA67;
}

.api-perm-card-content {
  text-align: center;
  padding-top: 8px;
}

.api-perm-card-content i {
  font-size: 26px;
  color: #444444;
  display: block;
  margin-bottom: 8px;
}

.api-perm-card-content strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
}

.api-perm-card-content span {
  display: block;
  font-size: 10px;
  margin: 0 auto;
  max-width: 160px;
  font-weight: 400;
  color: #9ca3af;
  line-height: 1.4;
}

.api-perm-card.active {
  border-color: #D1AA67;
  background: #fff;
}

.api-perm-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #F9FAFB;
}

.api-ip-input-box {
  border: 1px solid #E5E7EB;
  background-color: #F9FAFB;
  border-radius: 11px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.api-ip-input-box input {
  border: none !important;
  padding: 8px !important;
  flex: 1 1;
  min-width: 100px;
}

.api-ip-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.api-ip-chip {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 3px 8px;
  border-radius: 30px;
  font-size: 11px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.api-ip-chip i {
  cursor: pointer;
  color: #9ca3af;
}

.api-input-with-icon {
  position: relative;
}

.api-input-with-icon i {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  cursor: pointer;
  font-size: 18px;
}

.api-create-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.btn-back {
  background: #E5E7EB;
  border: none;
  padding: 12px 28px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-submit {
  background: #343539;
  color: #fff;
  border: none;
  padding: 12px 32px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.api-create-preview-section {
  flex: 1 1;
}

.api-create-preview-section h3 {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.api-preview-list {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.api-preview-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.preview-label {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #9CA3AF;
  font-size: 12px;
}

.preview-label i {
  background: #F9FAFB;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #4B5563;
  font-size: 18px;
}

.preview-value {
  text-align: right;
  font-size: 14px;
  color: #111827;
  display: flex;
  align-items: center;
  height: 40px;
}

.preview-perm-badge {
  background: #F0FDF4;
  color: #16A34A;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 500;
  margin-left: 6px;
}

/* Dark mode for Create form */
html[data-theme='dark'] body .api-breadcrumb {
  color: #9ca3af;
}

html[data-theme='dark'] body .api-breadcrumb .current {
  color: #fff;
}

html[data-theme='dark'] body .api-create-form-section h2,
html[data-theme='dark'] body .api-form-group label,
html[data-theme='dark'] body .api-perm-card-content strong,
html[data-theme='dark'] body .api-create-preview-section h3,
html[data-theme='dark'] body .preview-value {
  color: #fff;
}

html[data-theme='dark'] body .api-form-group input[type="text"],
html[data-theme='dark'] body .api-form-group input[type="password"],
html[data-theme='dark'] body .api-ip-input-box {
  background: #1a1a24;
  border-color: #333;
  color: #fff;
}

html[data-theme='dark'] body .api-select-trigger {
  background: #1a1a24;
  border-color: #333;
  color: #fff;
}

html[data-theme='dark'] body .api-select-options {
  background: #1a1a24;
  border-color: #333;
}

html[data-theme='dark'] body .api-select-options li {
  color: #ccc;
}

html[data-theme='dark'] body .api-select-options li:hover,
html[data-theme='dark'] body .api-select-options li.selected {
  background-color: rgba(209, 170, 103, 0.2);
  color: #D1AA67;
}

html[data-theme='dark'] body .api-perm-card {
  border-color: #333;
}

html[data-theme='dark'] body .api-perm-card.disabled {
  background: #1a1a24;
}

html[data-theme='dark'] body .api-perm-card.active {
  background: #332d2070;
  border-color: #d1aa6799;
}

html[data-theme='dark'] body .api-perm-card-content i {
  color: #ccc;
}

html[data-theme='dark'] body .api-ip-chip {
  background: #1a1a24;
  border-color: #333;
  color: #ccc;
}

html[data-theme='dark'] body .btn-back {
  background: #1a1a24;
  color: #ccc;
}

html[data-theme='dark'] body .preview-label i {
  background: #1a1a24;
  color: #ccc;
}

/* ==================== API KEY SUCCESS PAGE ==================== */
.api-success-card {
  max-width: 950px;
  margin: 40px auto;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
}

.api_succssful_bl {
  max-width: 670px;
  margin: 0 auto;
}

.api-success-icon-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
}

.api-success-icon {
  width: 72px;
  height: 72px;
  background: #DCFCE7;
  color: #16A34A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.api-success-icon-wrapper::before,
.api-success-icon-wrapper::after {
  content: '★';
  position: absolute;
  font-size: 16px;
}

.api-success-icon-wrapper::before {
  top: 10px;
  left: 0;
  color: #86EFAC;
}

.api-success-icon-wrapper::after {
  bottom: 20px;
  right: 0;
  color: #FDE047;
}

.api-success-card h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px;
}

.api-success-card p {
  font-size: 14px;
  color: #6B7280;
  margin: 0 0 32px;
  line-height: 1.6;
}

.api-success-box {
  display: flex;
  align-items: center;
  background: #F9FAFB;
  border: 1px solid #F3F4F6;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.api-success-box label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  width: 100px;
  text-align: left;
}

.api-success-input {
  flex: 1 1;
  display: flex;
  align-items: center;
  border: 1px solid #f1f5f900;
  border-radius: 6px;
  gap: 16px;
  background-color: #ffffff08;
  padding: 15px;
}

body.light_theme .api-success-input {
  border: 1px solid #F1F5F9;
  background-color: #fff;
}

.api-success-input input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 13px;
  color: #111827;
  outline: none;
}

.api-success-input i {
  color: #9CA3AF;
  cursor: pointer;
  font-size: 18px;
}

.api-success-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 40px;
}

.api-success-actions button {
  padding: 14px 36px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.btn-view {
  background: #E5E7EB;
  color: #374151;
}

.btn-done {
  background: #111827;
  color: #fff;
}

html[data-theme='dark'] body .api-success-card {
  background: #1a1a24;
  border-color: #333;
}

html[data-theme='dark'] body .api-success-card h2,
html[data-theme='dark'] body .api-success-card p {
  color: #fff;
}

html[data-theme='dark'] body .api-success-box {
  background: #1a1a24;
  border-color: #333;
}

html[data-theme='dark'] body .api-success-box label {
  color: #ccc;
}

html[data-theme='dark'] body .api-success-input input {
  color: #fff;
}

html[data-theme='dark'] body .btn-view {
  background: #333;
  color: #fff;
}


@media screen and (max-width:1500px) {

  .api-key-header h2 {
    font-size: 34px;
  }


}


@media screen and (max-width:1200px) {

  .api-key-header h2 {
    font-size: 28px;
  }

  .api-key-create-btn {
    padding: 12px 18px;
    white-space: nowrap;
    font-size: 12px;
  }

  .api-key-stats {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 30px;
  }

  .api-stat-info h3 {
    font-size: 24px;
  }

  .api-table td {
    padding: 15px;
    font-size: 12px;
  }

  .api-table-wrapper {
    overflow-x: hidden;
    padding: 24px 24px 0px;
  }

  .api-table,
  .api-table thead,
  .api-table tbody,
  .api-table th,
  .api-table td,
  .api-table tr {
    display: block;
    width: 100%;
  }

  .api-table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .api-table tr {
    border: 1px solid #f3f4f61c;
    border-radius: 12px;
    margin-bottom: 20px;
    background: transparent;
    padding: 10px;
  }

  html[data-theme='dark'] body .api-table tr {
    border: 1px solid #333;
    background: #1a1a24;
  }

  body.light_theme .api-table tr {
    border: 1px solid #F3F4F6;
    background: #fff;
  }

  .api-table td {
    border: none !important;
    position: relative;
    padding-left: 50% !important;
    text-align: right;
    min-height: 48px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-bottom: 1px solid #f3f4f61c !important;
  }

  .api-table td:last-child {
    border-bottom: none !important;
  }

  /* html[data-theme='dark'] body .api-table td {
    border-bottom: 1px solid #333 !important;
  } */

  body.light_theme .api-table td {
    border-bottom: 1px solid #F3F4F6 !important;
  }

  .api-pagination {
    margin: 0px 24px 24px;
  }

  .api-table td:before {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    content: attr(data-label);
    font-weight: 600;
    color: #9ca3af;
    text-align: left;
  }

  .api-key-toolbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .api-actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 15px;
  }

  .api-search {
    flex: 1 1;
    min-width: 200px;
  }

  .api-tabs {
    flex-wrap: wrap;
    gap: 16px;
    overflow-x: auto;
    width: 100%;
    padding-bottom: 5px;
  }

  .api-key-header p {
    max-width: 90%;
  }


}


@media screen and (max-width:991px) {

  .api-create-layout {
    gap: 20px;
  }

  .api-create-form-section h2 {
    font-size: 20px;
  }

}

@media screen and (max-width:767px) {

  .api-create-layout {
    flex-direction: column;
    gap: 32px;
  }

  .api-form-group label {
    font-size: 12px;
  }

  .api-breadcrumb {
    font-size: 13px;
  }

  .api-key-container {
    padding: 20px 0px 20px 0px;
  }

  .api-key-header h2 {
    font-size: 22px;
  }

  .api-key-header p {
    font-size: 14px;
  }

  .api-stat-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .api-stat-card {
    border-radius: 15px;
    min-height: 112px;
    padding: 15px;
  }

  .api-success-card {
    margin: 30px auto;
    padding: 24px;
  }

}


@media screen and (max-width:480px) {

  .api-success-card h2 {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .api-success-icon-wrapper {
    margin: 0 auto 15px;
  }

  .api-success-card p {
    margin: 0 0 22px;
  }

  .api-success-actions button {
    width: 100%;
    padding: 10px 15px;
    font-size: 13px;
  }

  .api-success-actions {
    gap: 12px;
    margin-top: 20px;
  }

  .api-success-input {
    gap: 10px;
    padding: 4px 7px;
    width: 100%;
  }

  .api-success-box {
    padding: 12px 18px;
    flex-direction: column;
    gap: 7px;
    align-items: start;
  }

  .api-key-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .api-permissions-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }

  .btn-submit {
    padding: 10px 24px;
    font-size: 12px;
  }

  .api-key-stats {
    gap: 10px;
  }

  .btn-back {
    padding: 10px 24px;
    font-size: 12px;
  }

  .preview-value {
    font-size: 12px;
  }

  .api-preview-item {
    gap: 12px;
  }

  .api-preview-list {
    margin-top: 20px;
    gap: 15px;
  }

  .api-stat-info p {
    font-size: 12px;
  }

  .api-stat-info h3 {
    font-size: 20px;
  }

  .api-stat-icon {
    width: 32px;
    height: 32px;
    font-size: 15px;
    border-radius: 7px;
  }

  .api-stat-card {
    gap: 10px;
    border-radius: 15px;
    min-height: 80px;
  }

  .api-key-toolbar {
    padding: 18px;
  }

  .api-tab {
    padding: 5px 0;
    font-size: 12px;
  }

  .api-tabs {
    gap: 10px;
  }

  .api-table-wrapper {
    padding: 18px 18px 0px;
  }

  .api-actions {
    flex-wrap: nowrap;
    gap: 10px;
  }


}

@media screen and (max-width:360px) {
  .api-actions {
    flex-wrap: wrap;
  }

  .api-filter-wrapper {
    width: 100%;
  }

  .api-filter-btn {
    justify-content: center;
    width: 100%;
  }

  .api-tabs {
    gap: 8px;
  }

  .api-tab {
    font-size: 11px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ApiKeyManagement/apikey.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iFAAiF;EACjF,WAAW;EACX,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;;AAGA;;EAEE;IACE,eAAe;EACjB;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;;;;;IAME,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;KAEG;;EAEH;IACE,2CAA2C;EAC7C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;;AAGF;;;AAGA;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;AAEF;;;AAGA;;EAEE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;;AAGF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* api key page */\n.api-key-container {\n  width: 100%;\n  padding: 24px 12px 40px 35px;\n  max-width: 100%;\n  background-color: #fff;\n  min-height: 100%;\n}\n\n/* Header */\n.api-key-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.api-key-header h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.api-key-header p {\n  color: #6b7280;\n  font-size: 15px;\n  margin: 0;\n}\n\n.api-key-create-btn {\n  background: #343539;\n  color: #fff;\n  border: none;\n  padding: 14px 24px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.api-key-create-btn:hover {\n  background: #1f2937;\n}\n\n/* Stats Cards */\n.api-key-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.api-stat-card {\n  border: 1px solid #F3F4F6;\n  border-radius: 18px;\n  min-height: 132px;\n  padding: 28px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #fff;\n  box-shadow: 0 0px 2px rgb(0 0 0 / 6%);\n}\n\n.api-stat-icon {\n  width: 65px;\n  height: 65px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.api-stat-icon.yellow {\n  background: #404246;\n  color: #ffffff;\n}\n\nbody.light_theme .api-stat-icon.yellow {\n  background: #FFFBEB;\n  color: #B98A2C;\n}\n\n.api-stat-icon.green {\n  background: #404246;\n  color: #ffffff;\n}\n\nbody.light_theme .api-stat-icon.green {\n  background: #F0FDF4;\n  color: #22C55E;\n}\n\n.api-stat-icon.gray {\n  background: #404246;\n  color: #ffffff;\n}\n\nbody.light_theme .api-stat-icon.gray {\n  background: #F9FAFB;\n  color: #6B7280;\n}\n\n.api-stat-icon.blue {\n  background: #404246;\n  color: #ffffff;\n}\n\nbody.light_theme .api-stat-icon.blue {\n  background: #EFF6FF;\n  color: #3B82F6;\n}\n\n.api-stat-info h3 {\n  margin: 0 0 1px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.api-stat-info p {\n  margin: 0;\n  font-size: 15px;\n  color: #6b7280;\n}\n\n/* Toolbar */\n.api-key-toolbar {\n  padding: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.apikeytabl_data {\n  width: 100%;\n  border: 1px solid #f3f4f61c;\n  border-radius: 16px;\n  /* margin: 26px 0px; */\n}\n\nbody.light_theme .apikeytabl_data {\n  border: 1px solid #F3F4F6;\n}\n\n.api-tabs {\n  display: flex;\n  gap: 32px;\n}\n\n.api-tab {\n  padding: 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6B7280;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: 0;\n}\n\n.api-tab.active {\n  color: #111827;\n  border-bottom-color: #D1AA67;\n}\n\n.api-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 0px;\n}\n\n.api-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 16px;\n  background: #fff;\n}\n\n.api-search i {\n  color: #9ca3af;\n}\n\n.api-search input {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  background: transparent;\n}\n\n.api-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n/* Table */\n.api-table-wrapper {\n  overflow-x: auto;\n}\n\n.api-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.api-table th {\n  text-align: left;\n  padding: 20px 30px;\n  font-size: 12px;\n  font-weight: 400;\n  background-color: #f9fafb08;\n  color: #8E939C;\n  border-bottom: 1px solid #f3f4f6;\n  white-space: nowrap;\n}\n\n.api-table td {\n  padding: 30px;\n  font-size: 13px;\n  color: #111827;\n  border-bottom: 1px solid #F3F4F6;\n  vertical-align: middle;\n}\n\n.api-remark-col {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.api-remark-icon {\n  width: 36px;\n  min-width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.api-remark-icon.yellow {\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.api-remark-icon.purple {\n  background: #F3E8FF;\n  color: #9333EA;\n}\n\n.api-remark-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.api-remark-sub {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.api-key-text {\n  font-family: monospace;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #4b5563;\n}\n\n.api-key-text i {\n  cursor: pointer;\n  color: #9ca3af;\n}\n\n.api-type-badge {\n  background: #D1FAE5;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 50px;\n}\n\n.api-type-badge.spot {\n  background: #ffe8ba;\n  color: #B98A2C;\n}\n\nbody.light_theme .api-type-badge.spot {\n  background: #FBF5E9;\n}\n\n.api-type-badge.margin {\n  background: #c8ffe5;\n  color: #059669;\n}\n\nbody.light_theme .api-type-badge.margin {\n  background: #ECFDF5;\n}\n\n.api-perm-badges {\n  display: flex;\n  gap: 6px;\n}\n\n.api-perm-badge {\n  background: #aff9d6;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\nbody.light_theme .api-perm-badge {\n  background: #ECFDF5;\n}\n\n.api-ip-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-weight: 500;\n}\n\n.api-ip-col span {\n  font-size: 10px;\n  color: #9ca3af;\n}\n\n.api-date-col {\n  color: #cfcfcf;\n  line-height: 1.5;\n  font-weight: 600;\n}\n\nbody.light_theme .api-date-col {\n  color: #4b5563;\n}\n\n.api-date-col div:last-child {\n  font-size: 10px;\n  font-weight: 300;\n  color: #9ca3af;\n}\n\n.api-status-active {\n  color: #10B981;\n  font-weight: 600;\n  font-size: 11px;\n  background-color: #ECFDF5;\n  padding: 4px 10px;\n  border-radius: 50px;\n}\n\n.api-status-disabled {\n  color: #6B7280;\n  font-weight: 600;\n  font-size: 11px;\n  background-color: #F3F4F6;\n  padding: 4px 10px;\n  border-radius: 50px;\n}\n\n.api-status-expired {\n  color: #EF4444;\n  font-weight: 600;\n  font-size: 11px;\n  background-color: #FEF2F2;\n  padding: 4px 10px;\n  border-radius: 50px;\n}\n\n.api-action-btns {\n  display: flex;\n  gap: 8px;\n}\n\n.api-action-btns button {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  color: #4b5563;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.api-action-btns button:hover {\n  background: #e5e7eb;\n}\n\n.api-action-btns button.delete {\n  color: #EF4444;\n}\n\n.api-action-btns button.delete:hover {\n  background: #FEF2F2;\n  border-color: #FECACA;\n}\n\n/* Pagination */\n.api-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 24px;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.api-page-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.api-page-controls button {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #374151;\n}\n\n.api-page-controls button.active {\n  background: #111827;\n  color: #fff;\n  border-color: #111827;\n}\n\n.api-page-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Dark theme overrides */\nhtml[data-theme='dark'] body .api-key-container {\n  background: transparent;\n}\n\nhtml[data-theme='dark'] body .api-key-header h2,\nhtml[data-theme='dark'] body .api-stat-info h3,\nhtml[data-theme='dark'] body .api-tab.active,\nhtml[data-theme='dark'] body .api-table td,\nhtml[data-theme='dark'] body .api-remark-title {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-stat-card {\n  background: #202226;\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-key-toolbar {\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-search,\nhtml[data-theme='dark'] body .api-filter-btn {\n  background: #1a1a24;\n  border-color: #333;\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-search input {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-table th,\nhtml[data-theme='dark'] body .api-table td {\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-key-text {\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-action-btns button {\n  background: #1a1a24;\n  border-color: #333;\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-page-controls button {\n  background: #1a1a24;\n  border-color: #333;\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-page-controls button.active {\n  background: #fff;\n  color: #111827;\n}\n\nhtml[data-theme='dark'] body .api-tab {\n  color: #888;\n}\n\nhtml[data-theme='dark'] body .api-tab.active {\n  color: #fff;\n}\n\n/* ==================== CREATE NEW API KEY ==================== */\n.api-create-container {\n  padding: 40px 20px;\n  max-width: 1360px;\n  margin: 0 auto;\n}\n\n.api-breadcrumb {\n  font-size: 15px;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.api-breadcrumb .current {\n  color: #111827;\n  font-weight: 600;\n}\n\n.api-create-layout {\n  display: flex;\n  gap: 60px;\n}\n\n.api-create-form-section {\n  flex: 1.5 1;\n}\n\n.api-create-form-section h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.subtitle {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 32px;\n}\n\n.api-form-group {\n  margin-bottom: 24px;\n}\n\n.api-form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 8px;\n}\n\n.api-form-group label .optional {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.api-form-group input[type=\"text\"],\n.api-form-group input[type=\"password\"] {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #ededed;\n  border-radius: 12px;\n  font-size: 13px;\n  outline: none;\n  background: none;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.api-form-group input[type=\"password\"] {\n  background-color: #ffffff05 !important;\n}\n\n.api-form-group input:focus {\n  border-color: #D1AA67;\n}\n\n.api-custom-select {\n  position: relative;\n  width: 100%;\n}\n\n.api-select-trigger {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #F3F4F6;\n  border-radius: 12px;\n  font-size: 13px;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.api-select-trigger:hover {\n  border-color: #D1AA67;\n}\n\n.api-select-trigger i {\n  color: #9ca3af;\n  font-size: 16px;\n}\n\n.api-filter-wrapper {\n  position: relative;\n}\n\n.api-filter-dropdown {\n  left: auto;\n  right: 0;\n  min-width: 150px;\n}\n\n.api-select-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  z-index: 10;\n  padding: 4px 0;\n  margin: 0;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.api-select-options li {\n  padding: 10px 16px;\n  font-size: 13px;\n  color: #111827;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.api-select-options li:hover,\n.api-select-options li.selected {\n  background-color: #D1AA67;\n  color: #fff;\n}\n\n.hint {\n  display: block;\n  font-style: italic;\n  font-size: 10px;\n  color: #9CA3AF;\n  margin-top: 8px;\n}\n\n.api-permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.api-perm-card {\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 24px 16px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.api-perm-card input[type=\"checkbox\"] {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  accent-color: #D1AA67;\n}\n\n.api-perm-card-content {\n  text-align: center;\n  padding-top: 8px;\n}\n\n.api-perm-card-content i {\n  font-size: 26px;\n  color: #444444;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.api-perm-card-content strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.api-perm-card-content span {\n  display: block;\n  font-size: 10px;\n  margin: 0 auto;\n  max-width: 160px;\n  font-weight: 400;\n  color: #9ca3af;\n  line-height: 1.4;\n}\n\n.api-perm-card.active {\n  border-color: #D1AA67;\n  background: #fff;\n}\n\n.api-perm-card.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #F9FAFB;\n}\n\n.api-ip-input-box {\n  border: 1px solid #E5E7EB;\n  background-color: #F9FAFB;\n  border-radius: 11px;\n  padding: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.api-ip-input-box input {\n  border: none !important;\n  padding: 8px !important;\n  flex: 1;\n  min-width: 100px;\n}\n\n.api-ip-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.api-ip-chip {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  padding: 3px 8px;\n  border-radius: 30px;\n  font-size: 11px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.api-ip-chip i {\n  cursor: pointer;\n  color: #9ca3af;\n}\n\n.api-input-with-icon {\n  position: relative;\n}\n\n.api-input-with-icon i {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.api-create-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 40px;\n}\n\n.btn-back {\n  background: #E5E7EB;\n  border: none;\n  padding: 12px 28px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-submit {\n  background: #343539;\n  color: #fff;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.api-create-preview-section {\n  flex: 1;\n}\n\n.api-create-preview-section h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.api-preview-list {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.api-preview-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.preview-label {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  color: #9CA3AF;\n  font-size: 12px;\n}\n\n.preview-label i {\n  background: #F9FAFB;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: #4B5563;\n  font-size: 18px;\n}\n\n.preview-value {\n  text-align: right;\n  font-size: 14px;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.preview-perm-badge {\n  background: #F0FDF4;\n  color: #16A34A;\n  padding: 2px 8px;\n  border-radius: 2px;\n  font-size: 10px;\n  font-weight: 500;\n  margin-left: 6px;\n}\n\n/* Dark mode for Create form */\nhtml[data-theme='dark'] body .api-breadcrumb {\n  color: #9ca3af;\n}\n\nhtml[data-theme='dark'] body .api-breadcrumb .current {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-create-form-section h2,\nhtml[data-theme='dark'] body .api-form-group label,\nhtml[data-theme='dark'] body .api-perm-card-content strong,\nhtml[data-theme='dark'] body .api-create-preview-section h3,\nhtml[data-theme='dark'] body .preview-value {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-form-group input[type=\"text\"],\nhtml[data-theme='dark'] body .api-form-group input[type=\"password\"],\nhtml[data-theme='dark'] body .api-ip-input-box {\n  background: #1a1a24;\n  border-color: #333;\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-select-trigger {\n  background: #1a1a24;\n  border-color: #333;\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-select-options {\n  background: #1a1a24;\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-select-options li {\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-select-options li:hover,\nhtml[data-theme='dark'] body .api-select-options li.selected {\n  background-color: rgba(209, 170, 103, 0.2);\n  color: #D1AA67;\n}\n\nhtml[data-theme='dark'] body .api-perm-card {\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-perm-card.disabled {\n  background: #1a1a24;\n}\n\nhtml[data-theme='dark'] body .api-perm-card.active {\n  background: #332d2070;\n  border-color: #d1aa6799;\n}\n\nhtml[data-theme='dark'] body .api-perm-card-content i {\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-ip-chip {\n  background: #1a1a24;\n  border-color: #333;\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .btn-back {\n  background: #1a1a24;\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .preview-label i {\n  background: #1a1a24;\n  color: #ccc;\n}\n\n/* ==================== API KEY SUCCESS PAGE ==================== */\n.api-success-card {\n  max-width: 950px;\n  margin: 40px auto;\n  background: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  padding: 60px 40px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n}\n\n.api_succssful_bl {\n  max-width: 670px;\n  margin: 0 auto;\n}\n\n.api-success-icon-wrapper {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto 24px;\n}\n\n.api-success-icon {\n  width: 72px;\n  height: 72px;\n  background: #DCFCE7;\n  color: #16A34A;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n\n.api-success-icon-wrapper::before,\n.api-success-icon-wrapper::after {\n  content: '★';\n  position: absolute;\n  font-size: 16px;\n}\n\n.api-success-icon-wrapper::before {\n  top: 10px;\n  left: 0;\n  color: #86EFAC;\n}\n\n.api-success-icon-wrapper::after {\n  bottom: 20px;\n  right: 0;\n  color: #FDE047;\n}\n\n.api-success-card h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 16px;\n}\n\n.api-success-card p {\n  font-size: 14px;\n  color: #6B7280;\n  margin: 0 0 32px;\n  line-height: 1.6;\n}\n\n.api-success-box {\n  display: flex;\n  align-items: center;\n  background: #F9FAFB;\n  border: 1px solid #F3F4F6;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 16px;\n}\n\n.api-success-box label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  width: 100px;\n  text-align: left;\n}\n\n.api-success-input {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n  border: 1px solid #f1f5f900;\n  border-radius: 6px;\n  gap: 16px;\n  background-color: #ffffff08;\n  padding: 15px;\n}\n\nbody.light_theme .api-success-input {\n  border: 1px solid #F1F5F9;\n  background-color: #fff;\n}\n\n.api-success-input input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  color: #111827;\n  outline: none;\n}\n\n.api-success-input i {\n  color: #9CA3AF;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.api-success-actions {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 40px;\n}\n\n.api-success-actions button {\n  padding: 14px 36px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n}\n\n.btn-view {\n  background: #E5E7EB;\n  color: #374151;\n}\n\n.btn-done {\n  background: #111827;\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-success-card {\n  background: #1a1a24;\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-success-card h2,\nhtml[data-theme='dark'] body .api-success-card p {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .api-success-box {\n  background: #1a1a24;\n  border-color: #333;\n}\n\nhtml[data-theme='dark'] body .api-success-box label {\n  color: #ccc;\n}\n\nhtml[data-theme='dark'] body .api-success-input input {\n  color: #fff;\n}\n\nhtml[data-theme='dark'] body .btn-view {\n  background: #333;\n  color: #fff;\n}\n\n\n@media screen and (max-width:1500px) {\n\n  .api-key-header h2 {\n    font-size: 34px;\n  }\n\n\n}\n\n\n@media screen and (max-width:1200px) {\n\n  .api-key-header h2 {\n    font-size: 28px;\n  }\n\n  .api-key-create-btn {\n    padding: 12px 18px;\n    white-space: nowrap;\n    font-size: 12px;\n  }\n\n  .api-key-stats {\n    grid-template-columns: repeat(2, 1fr);\n    margin-bottom: 30px;\n  }\n\n  .api-stat-info h3 {\n    font-size: 24px;\n  }\n\n  .api-table td {\n    padding: 15px;\n    font-size: 12px;\n  }\n\n  .api-table-wrapper {\n    overflow-x: hidden;\n    padding: 24px 24px 0px;\n  }\n\n  .api-table,\n  .api-table thead,\n  .api-table tbody,\n  .api-table th,\n  .api-table td,\n  .api-table tr {\n    display: block;\n    width: 100%;\n  }\n\n  .api-table thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .api-table tr {\n    border: 1px solid #f3f4f61c;\n    border-radius: 12px;\n    margin-bottom: 20px;\n    background: transparent;\n    padding: 10px;\n  }\n\n  html[data-theme='dark'] body .api-table tr {\n    border: 1px solid #333;\n    background: #1a1a24;\n  }\n\n  body.light_theme .api-table tr {\n    border: 1px solid #F3F4F6;\n    background: #fff;\n  }\n\n  .api-table td {\n    border: none !important;\n    position: relative;\n    padding-left: 50% !important;\n    text-align: right;\n    min-height: 48px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    border-bottom: 1px solid #f3f4f61c !important;\n  }\n\n  .api-table td:last-child {\n    border-bottom: none !important;\n  }\n\n  /* html[data-theme='dark'] body .api-table td {\n    border-bottom: 1px solid #333 !important;\n  } */\n\n  body.light_theme .api-table td {\n    border-bottom: 1px solid #F3F4F6 !important;\n  }\n\n  .api-pagination {\n    margin: 0px 24px 24px;\n  }\n\n  .api-table td:before {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    transform: translateY(-50%);\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    content: attr(data-label);\n    font-weight: 600;\n    color: #9ca3af;\n    text-align: left;\n  }\n\n  .api-key-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n\n  .api-actions {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n\n  .api-search {\n    flex: 1;\n    min-width: 200px;\n  }\n\n  .api-tabs {\n    flex-wrap: wrap;\n    gap: 16px;\n    overflow-x: auto;\n    width: 100%;\n    padding-bottom: 5px;\n  }\n\n  .api-key-header p {\n    max-width: 90%;\n  }\n\n\n}\n\n\n@media screen and (max-width:991px) {\n\n  .api-create-layout {\n    gap: 20px;\n  }\n\n  .api-create-form-section h2 {\n    font-size: 20px;\n  }\n\n}\n\n@media screen and (max-width:767px) {\n\n  .api-create-layout {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .api-form-group label {\n    font-size: 12px;\n  }\n\n  .api-breadcrumb {\n    font-size: 13px;\n  }\n\n  .api-key-container {\n    padding: 20px 0px 20px 0px;\n  }\n\n  .api-key-header h2 {\n    font-size: 22px;\n  }\n\n  .api-key-header p {\n    font-size: 14px;\n  }\n\n  .api-stat-icon {\n    width: 48px;\n    height: 48px;\n    font-size: 20px;\n  }\n\n  .api-stat-card {\n    border-radius: 15px;\n    min-height: 112px;\n    padding: 15px;\n  }\n\n  .api-success-card {\n    margin: 30px auto;\n    padding: 24px;\n  }\n\n}\n\n\n@media screen and (max-width:480px) {\n\n  .api-success-card h2 {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n\n  .api-success-icon-wrapper {\n    margin: 0 auto 15px;\n  }\n\n  .api-success-card p {\n    margin: 0 0 22px;\n  }\n\n  .api-success-actions button {\n    width: 100%;\n    padding: 10px 15px;\n    font-size: 13px;\n  }\n\n  .api-success-actions {\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .api-success-input {\n    gap: 10px;\n    padding: 4px 7px;\n    width: 100%;\n  }\n\n  .api-success-box {\n    padding: 12px 18px;\n    flex-direction: column;\n    gap: 7px;\n    align-items: start;\n  }\n\n  .api-key-header {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .api-permissions-grid {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 12px;\n  }\n\n  .btn-submit {\n    padding: 10px 24px;\n    font-size: 12px;\n  }\n\n  .api-key-stats {\n    gap: 10px;\n  }\n\n  .btn-back {\n    padding: 10px 24px;\n    font-size: 12px;\n  }\n\n  .preview-value {\n    font-size: 12px;\n  }\n\n  .api-preview-item {\n    gap: 12px;\n  }\n\n  .api-preview-list {\n    margin-top: 20px;\n    gap: 15px;\n  }\n\n  .api-stat-info p {\n    font-size: 12px;\n  }\n\n  .api-stat-info h3 {\n    font-size: 20px;\n  }\n\n  .api-stat-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 15px;\n    border-radius: 7px;\n  }\n\n  .api-stat-card {\n    gap: 10px;\n    border-radius: 15px;\n    min-height: 80px;\n  }\n\n  .api-key-toolbar {\n    padding: 18px;\n  }\n\n  .api-tab {\n    padding: 5px 0;\n    font-size: 12px;\n  }\n\n  .api-tabs {\n    gap: 10px;\n  }\n\n  .api-table-wrapper {\n    padding: 18px 18px 0px;\n  }\n\n  .api-actions {\n    flex-wrap: nowrap;\n    gap: 10px;\n  }\n\n\n}\n\n@media screen and (max-width:360px) {\n  .api-actions {\n    flex-wrap: wrap;\n  }\n\n  .api-filter-wrapper {\n    width: 100%;\n  }\n\n  .api-filter-btn {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .api-tabs {\n    gap: 8px;\n  }\n\n  .api-tab {\n    font-size: 11px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
